import React, {useCallback, useState} from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color';

function ColorPicker(props) {
    const {color, onChange} = props;

    const [displayColorPicker, setDisplayColorPicker] = useState(false);

    const onOpen = useCallback(() => {
        setDisplayColorPicker(true);
    }, []);

    const onClose = useCallback(() => {
        setDisplayColorPicker(false);
    }, []);

    const styles = reactCSS({
        'default': {
            color: {
                width: 81,
                height: 27,
                borderRadius: '2px',
                background: color,
            },
            swatch: {
                padding: '4px',
                background: '#fff',
                display: 'inline-block',
                cursor: 'pointer',
                border: '1px solid #CCCCCC',
            },
            popover: {
                position: 'absolute',
                zIndex: '2',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        },
    });

    return (
        <div>
            <div style={styles.swatch} onClick={onOpen}>
                <div style={styles.color} />
            </div>
            { displayColorPicker ? <div style={styles.popover}>
                <div style={styles.cover} onClick={onClose}/>
                <SketchPicker color={color} onChange={(value) => onChange(value.hex)} />
            </div> : null }

        </div>
    )

}

export default ColorPicker